import { api } from './client';

export interface UserInfo {
  id: number;
  usuario: string;
  nome_completo?: string;
  email?: string;
  ativo?: boolean;
}

export async function login(usuario: string, senha: string): Promise<UserInfo> {
  const { data } = await api.post('/auth/login', { usuario, senha });
  return data.user as UserInfo;
}

export async function logout(): Promise<void> {
  await api.post('/auth/logout');
}

export async function me(): Promise<UserInfo> {
  const { data } = await api.get('/auth/me');
  return data as UserInfo;
}
